import React, {useState} from "react";
import axios from "axios";
import url from "../../function/url";
import Navbar from '../../components/Navbar';
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
function  CompanyDetails() {
    const ID = Cookies.get("log_id");
    const navigate = useNavigate();
    const [industry,setIndustry] = useState("");
    const [registration,setRegistration] = useState("");
    const [Product,setProduct] = useState("");
    const [website,setWebsite] = useState("");
    const [file, setFile] = useState(null);
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
    function  handleSubmit(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('industry',industry);
        formdata.append('registration',registration);
        formdata.append('product',Product);
        formdata.append('website',website);
        if (file){
            formdata.append('file',file);
        }
        axios
      .put(`${url.path}/company_reg2/`, formdata)
      .then((res) => {
        navigate("/company_information")

      })
      .catch((err) => {
        Toast.fire({
          icon:'error',
          title:err
        })
      });
    }
    return(
        <>
        <Navbar />
        <div className="company-form-container">
      <div className="form-wrapper">
        
        <div className="form-section">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="companyType">Industry Type</label>
              
              <select id="industry" value={industry} onChange={(e) =>setIndustry(e.target.value)}>
                <option value="" selected>--Select--</option>
                <option value="Tech">Tech</option>
                <option value="IT">IT</option>
                <option value="Business">Business</option>
                <option value="E-commerce">E-commerce</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="companyDepartments">Registration Number</label>
              <input id="companyDepartments" type="text" placeholder="Registration Number" value={registration} onChange={(e) =>setRegistration(e.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="businessActivity">Product/Services</label>
              <input type="text" placeholder="Product/Services" value={Product} onChange={(e) =>setProduct(e.target.value)} />
            </div>
            <div className="form-group">
              <label htmlFor="companyWebsite">Company Website</label>
              <input id="companyWebsite" type="text" placeholder="Enter website URL" value={website} onChange={(e) =>setWebsite(e.target.value)} />
            </div>
            <button type="submit" className="submit-btn">Continue →</button>
          </form>
        </div>

      
        <div className="logo-section">
          
          <div className="upload-wrapper">
          <h3>Add Document</h3>
            <label htmlFor="companyLogo" className="file-upload">
              <div className="upload-box">
                <i className="upload-icon">↑</i>
                <span>Choose File</span>
                <span className="file-chosen">No file chosen</span>
              </div>
              <input id="companyLogo" type="file" onChange={(e) => setFile(e.target.files[0])} />
            </label>
          </div>
        </div>
      </div>
    </div>
        </>
    );
}
export default CompanyDetails;
  